import React, { useContext, useMemo } from "react";
import { gql, useQuery } from "@apollo/client";
import Spinner from "../components/Spinner";
import StarekContext from "../context/StarekContext";
import MaintenanceSchedulesCalendar from "../components/Maintenance/MaintenanceSchedulesCalendar";

export const GET_DEVICES_IN_PLANT = gql`
    query GetDevicesForPlant($where: ShadowDeviceWhereInput) {
        shadowDevices(where: $where) {
            id
            name
            maintenance_schedules {
                schedule_type
                schedule_attributes
            }
        }
    }
`;

const Maintenance = () => {
    const starekContext = useContext(StarekContext);

    // const plantId =
    //   starekContext?.selectedPlant?.id ||
    //   starekContext?.activePlant?.id ||
    //   starekContext?.currentPlant?.id ||
    //   null;

    const plantId = starekContext.lastUsedPlant?.id;

    const where = useMemo(
        () => (plantId ? { plant_id: { equals: Number(plantId) } } : undefined),
        [plantId]
    );

    const { data, loading, error, refetch } = useQuery(GET_DEVICES_IN_PLANT, {
        variables: { where },
        client: starekContext.engineClient,
        fetchPolicy: "network-only",
    });

    const devices = data?.shadowDevices || [];

    return loading ? (
        <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ minHeight: "100vh" }}
        >
            <div className="text-xs d-flex justify-content-center">
                <i className="fa fa-cogs fa-10x text-success"></i>
            </div>
            <Spinner />
        </div>
    ) : error ? (
        <div className="tw-text-center tw-mt-10 tw-text-red-600">
            Failed to load maintenance schedules: {error.message}
        </div>
    ) : (
        <div>
            <MaintenanceSchedulesCalendar
                devices={devices}
                onRefresh={refetch}
            />
        </div>
    );
};

export { Maintenance };
